import { Injectable } from '@angular/core';
import { GetAllResponse, SingleResponse } from '../model/restful-api.model';
import { environment } from 'src/environments/environment';
import { API_URL } from '../enums/api-enums';
import { Observable } from 'rxjs';
import { UtilitiesService } from 'src/app/core/services/utilities.service';
import { IntelexSupplierAudit } from '../model/intelexSupplierAudit.model';
import { TicketRequest } from '../model/ticket-access-request.model';

@Injectable({
  providedIn: 'root'
})

export class IntelexSupplierAuditService {

  constructor(private utilities: UtilitiesService) { }

  requestIntelexSupplierAuditAccess(body): Observable<GetAllResponse<IntelexSupplierAudit>> {
    const url = environment.portalURL + API_URL.INTELEX_SUPPLIER_AUDIT_REQUEST_URL;
    return this.utilities.req.httpPost<GetAllResponse<IntelexSupplierAudit>>(url, body);
  }

  getRequestIntelexSupplierAuditAccess(id): Observable<GetAllResponse<IntelexSupplierAudit>> {
    const url = environment.portalURL + API_URL.INTELEX_SUPPLIER_AUDIT_REQUEST_URL + `${id}`;
    return this.utilities.req.httpGet<GetAllResponse<IntelexSupplierAudit>>(url);
  }

  getRequestIntelexSupplierAuditAccessList(): Observable<GetAllResponse<TicketRequest>> {
    const url = environment.portalURL + API_URL.INTELEX_SUPPLIER_AUDIT_REQUEST_URL;
    return this.utilities.req.httpGet<GetAllResponse<TicketRequest>>(url);
  }

  getSSOList(body): Observable<GetAllResponse<TicketRequest>> {
    const url = environment.portalURL + API_URL.SSO_URL + `?firstName=${body.firstName}&lastName=${body.lastName}&email=${body.email}`;
    return this.utilities.req.httpGet<GetAllResponse<TicketRequest>>(url);
  }

  createSupportCentralForm(body): Observable<GetAllResponse<IntelexSupplierAudit>> {
    const url = API_URL.SUPPORT_CENTRAL_INTELEX_CREATE;
    return this.utilities.req.httpPost<SingleResponse<any>>(url, body);
  }
}
